import { render, staticRenderFns } from "./house-list.vue?vue&type=template&id=1064a827&scoped=true&"
import script from "./house-list.vue?vue&type=script&lang=js&"
export * from "./house-list.vue?vue&type=script&lang=js&"
import style0 from "./house-list.vue?vue&type=style&index=0&id=1064a827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064a827",
  null
  
)

export default component.exports